import React from "react";

function ChevronLeft({ color = "#767C8F", size = 13 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.13488 10.822L-0.45512 9.2305L8.21038 0.562004C8.34923 0.422272 8.51435 0.311379 8.69622 0.235707C8.8781 0.160035 9.07314 0.121078 9.27013 0.121078C9.46712 0.121078 9.66216 0.160035 9.84404 0.235707C10.0259 0.311379 10.191 0.422272 10.3299 0.562004L18.9999 9.2305L17.4099 10.8205L9.27238 2.6845L1.13488 10.822Z"
        fill={color}
      />
    </svg>
  );
}

export default ChevronLeft;
